import { Component } from 'react';

import { twclsx } from 'utils/twclsx';

interface IconComponentProps {
    className?: string;
    currentColor?: string;
    fill?: string;
    viewBox?: string;
    strokeWidth?: string;
    children?: string | JSX.Element | JSX.Element[];
}

class Icon extends Component<IconComponentProps> {
    render() {
        const { className, strokeWidth, children, currentColor, fill, viewBox } = this.props;

        return (
            <svg
                viewBox={viewBox || '0 0 24 24'}
                strokeWidth={strokeWidth || '1.5'}
                stroke={currentColor || 'currentColor'}
                fill={fill || 'none'}
                strokeLinecap="round"
                strokeLinejoin="round"
                className={twclsx('w-5', 'h-5', 'text-gray-500', className)}
            >
                {children}
            </svg>
        );
    }
}

export default Icon;
